import { render, staticRenderFns } from "./MyUserInventoryLimitsList.vue?vue&type=template&id=49a7cb38&scoped=true"
import script from "./MyUserInventoryLimitsList.vue?vue&type=script&lang=js"
export * from "./MyUserInventoryLimitsList.vue?vue&type=script&lang=js"
import style0 from "./MyUserInventoryLimitsList.vue?vue&type=style&index=0&id=49a7cb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7cb38",
  null
  
)

export default component.exports